export default "/images/3067a6275efeb35839ee5f180f235f3c.jpg";